import React, { useState, useEffect } from 'react';
import { getLandingIMessageHref, LANDING_CTA_TEXT } from './LandingConstants';

const COUNTDOWN_HOURS = 12;
const MS_PER_HOUR = 60 * 60 * 1000;

const pad2 = (n) => String(Math.max(0, Math.floor(n))).padStart(2, '0');

const LandingFinalConversionSection = () => {
  const [endTime] = useState(() => Date.now() + COUNTDOWN_HOURS * MS_PER_HOUR);
  const [timeLeft, setTimeLeft] = useState({ h: COUNTDOWN_HOURS, m: 0, s: 0 });

  useEffect(() => {
    const tick = () => {
      const diff = endTime - Date.now();
      if (diff <= 0) {
        setTimeLeft({ h: 0, m: 0, s: 0 });
        return;
      }
      const h = Math.floor(diff / MS_PER_HOUR);
      const m = Math.floor((diff % MS_PER_HOUR) / (60 * 1000));
      const s = Math.floor((diff % (60 * 1000)) / 1000);
      setTimeLeft({ h, m, s });
    };

    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [endTime]);

  const timerDisplay = `${pad2(timeLeft.h)}:${pad2(timeLeft.m)}:${pad2(timeLeft.s)}`;

  return (
    <section className="landing-final-conversion">
      <div className="landing-final-conversion__inner">
        <h2 className="landing-final-conversion__headline">
          FREE Jet Ski Offer Ends Soon
        </h2>
        <p className="landing-final-conversion__subheadline">
          Only a few premium charters per day.
          <br />
          When the timer hits zero, the Jet Ski is gone.
        </p>
        <div className="landing-final-conversion__countdown">
          <span className="landing-final-conversion__countdown-emoji" aria-hidden="true">
            ⏰
          </span>
          <span className="landing-final-conversion__countdown-timer">{timerDisplay}</span>
        </div>
        <p className="landing-final-conversion__supporting">
          One message. We check availability. You enjoy Miami.
        </p>
        <div className="landing-final-conversion__cta-wrapper">
          <a
            href={getLandingIMessageHref()}
            className="landing-hero__cta"
            rel="noopener noreferrer"
          >
            {LANDING_CTA_TEXT}
          </a>
        </div>
      </div>
    </section>
  );
};

export default LandingFinalConversionSection;
